import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { renderHeaderButton } from '../../../../../store/headerButtonControl/duck';
import TemplatePicker from './component';

const container = connect(
  (state: any) => ({
    userDetails: state.user.userDetails,
    subscriptions: state.userSubscription.subscriptions,
    hotTopic: state.functions.hotTopic
  }),
  {
    renderHeaderButton
  }
)(TemplatePicker);

export default injectIntl(container);
